export const SEARCH_LIST_ATTEMPT = 'SEARCH_LIST_ATTEMPT';
export const SEARCH_LIST_SUCCESS = 'SEARCH_LIST_SUCCESS';
export const SEARCH_LIST_FAILED = 'SEARCH_LIST_FAILED';

